<script setup>
    import { Delete } from '@element-plus/icons-vue';

    const props = defineProps(['modelValue', 'data', 'node', 'product']);

    const addFile = () => {
        const mediaUploader = wp.media({
            title: 'Select Product File',
            button: {
                text: 'Select Product File'
            },
            multiple: false
        });

        mediaUploader.on('select', () => {
            const attachment = mediaUploader.state().get('selection').first().toJSON();
            props.data.file = attachment.url;
            props.data.name = attachment.title;
        });

        mediaUploader.open();
    }


</script>
<template>
    
   <span class="fpe-download-file">
        <ElInput v-model="props.data.name" />
        <ElInput v-model="props.data.file" />
        <ElButton type="primary" size="large" @click="addFile">Choose File</ElButton>
       <el-button type="danger" :icon="Delete" circle @click="$emit('ondelete', props.node.id)"/>
    </span>
</template>